import CloseIcon from '@mui/icons-material/Close';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import {
  CREDIT_SCORE_V2_MODAL_OPEN,
  DIGITAL_RETAILING_MODAL_CLOSE,
  LOCAL_STORAGE_KEYS,
} from 'constants/CommonConstants';
import useQueryParams from 'hooks/UseQueryParams';
import i18n from 'i18next';
import React, { useEffect, useState } from 'react';
import { FieldValues, SubmitHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Lottie from 'react-lottie-player';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import DynamicStepperForm from 'sharedComponents/dynamicStepperForm';
import { StepConfigItem } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import { DefaultModal } from 'sharedComponents/modal';
import { authenticate } from 'store/Auth';
import { clearLeadCreation, employeeHistory } from 'store/CreditScoreState';
import { RootState } from 'store/store';
import { MODULE_NAME } from './DigitalRetailingConstant';
import { EmploymentDetails } from './DigitalRetailingInterface';
import { creditScoreStepConfig1 } from './StepConfig';
import ParentHeader from './components/header/ParentHeader';
import './digital-retailing.scss';
import celebrationMain from './json-animation/celebration-main.json';
import celebration from './json-animation/celebration.json';

const DigitalRetailing: React.FC = () => {
  const { t } = useTranslation();
  const { token } = useParams();

  const hasCalledMounted = React.useRef(false);

  const queryParams = useQueryParams();

  const domain = queryParams.get('domain');
  const type = queryParams.get('type');
  const version = queryParams.get('version');
  const VIN = queryParams.get('VIN');

  console.log('VIN', VIN);

  const [isSuccessModal, setIsSuccessModal] = useState<boolean>(false);
  const [initialStep, setInitialStep] = React.useState(0);

  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();

  const { authenticateClientData } = useSelector((state: RootState) => state.auth) || {};

  const {
    publicLeadCreationData: { data: { Lead: { _id } = { _id: '' } } = { Lead: { _id: '' } } },
  } = useSelector((state: RootState) => state.creditScoreStore);

  let className;

  if (type === 'button' || type === 'banner') {
    className = 'csc-screens csc-screens--modal';
  } else if (type === 'embed') {
    className = 'csc-screens csc-screens--embedded';
  } else {
    className = 'csc-screens csc-screens--full-page';
  }

  useEffect(() => {
    i18n.changeLanguage(authenticateClientData?.data?.widgetData?.language || 'en');
  }, [authenticateClientData]);

  useEffect(() => {
    if (hasCalledMounted.current) return;
    hasCalledMounted.current = true;

    if (window.self !== window.top) {
      // document.body.classList.add('credit-modal-open');
    }
  }, []);

  const clearLocalStorage = () => {
    localStorage.setItem(`${MODULE_NAME}-currentStep`, '0');
    localStorage.removeItem(MODULE_NAME);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.draftLeadId);
    dispatch(clearLeadCreation());
    // setIsSuccessModal(true);
    setInitialStep(1);
  };

  const handleFinalSubmit: SubmitHandler<FieldValues> = async (formData) => {
    console.log('formData', formData);

    const appointmentDate = {
      date: formData.calendar_appointmentDate,
      firstName: formData.calendar_firstname,
      lastName: formData.calendar_lastname,
      email: formData.calendar_emailaddress,
      phone: formData.calendar_phone,
      address: formData.calendar_address?.label,
      time: formData.calendar_time,
    };

    console.log('appointmentDate', appointmentDate);

    // dispatch(bookAnAppointment(appointmentDate)).then((res) => {
    //   if (Object.keys(res?.payload).length && res?.payload?.message) {
    //     clearLocalStorage();
    //   }
    // });

    return;
    const {
      grossMonth,
      timeAtJobYear,
      timeAtJobMonth,
      currentEmployerName,
      jobTitle,
      recidenceYear,
      recidenceMonth,
      rentOrOwn,
      monthlyHousePayment,
    } = formData;

    const updatedData: EmploymentDetails = {
      address: {
        yearsAtResidence: recidenceYear,
        monthsAtResidence: recidenceMonth,
      },
      employeeHistory: {
        yearsAtJob: timeAtJobYear,
        monthsAtJob: timeAtJobMonth,
        employer: currentEmployerName,
        income: grossMonth,
        occupation: jobTitle,
      },
      homeMortgage: {
        residenceType: rentOrOwn,
        monthlyMortgageOrRent: monthlyHousePayment,
      },
      leadId: _id,
    };

    dispatch(employeeHistory(updatedData)).then((res) => {
      if (Object.keys(res?.payload).length && res?.payload?.message) {
        clearLocalStorage();
      }
    });
  };

  const onCloseModal = () => {
    window.parent.postMessage(
      { type: DIGITAL_RETAILING_MODAL_CLOSE, data: { close: true }, res: { module: 'digital-retailing' } },
      '*'
    );
    clearLocalStorage();
  };

  const stepConfigsByTypeAndVersion: {
    [type: string]: { [version: string]: StepConfigItem[] };
  } = {
    banner: {
      '1.0': creditScoreStepConfig1(t),
    },
    button: {
      '1.0': creditScoreStepConfig1(t),
    },
    embed: {
      '1.0': creditScoreStepConfig1(t),
    },
  };

  const getStepConfig = (type: string | null, version: string | null): StepConfigItem[] => {
    if (!type || !version) {
      console.error('Invalid type or version');
      return [];
    }

    const typeConfig = stepConfigsByTypeAndVersion[type];
    if (!typeConfig) {
      console.error('Unknown type:', type);
      return [];
    }

    const config = typeConfig[version];
    if (!config) {
      console.error(`No configuration found for type "${type}" and version "${version}"`);
      return [];
    }

    return config;
  };

  const stepConfig = getStepConfig(type, version);

  return (
    <>
      <div className='dr-widget-wrapper'>
        {window.self !== window.top && (
          <header className='d-none'>
            <span className='close' onClick={onCloseModal}>
              <CloseIcon />
            </span>
          </header>
        )}
        {version != null ? (
          <DynamicStepperForm
            stepConfig={stepConfig}
            initialStep={initialStep}
            onFinish={handleFinalSubmit}
            moduleConfig={{
              name: MODULE_NAME,
              stepperHeader: <ParentHeader onCloseModal={onCloseModal} />,
            }}
          />
        ) : null}
      </div>

      <DefaultModal
        open={isSuccessModal}
        handleClose={() => {
          setIsSuccessModal(false);
          onCloseModal();
        }}
        customClass='csc-thankyou-modal'
        childern={
          <div className='modal-body'>
            <p className='csc-thankyou-modal__title fw-600'>{t('leadGen.successMsg')}</p>
            <div className='csc-thankyou-modal__lottie-animation'>
              <div className='csc-thankyou-modal__lottie-animation__left'>
                <Lottie loop animationData={celebration} play className='' />
              </div>
              <div className='csc-thankyou-modal__lottie-animation__middle'>
                <Lottie loop animationData={celebrationMain} play className='' />
              </div>
              <div className='csc-thankyou-modal__lottie-animation__right'>
                <Lottie loop animationData={celebration} play className='' />
              </div>
            </div>
          </div>
        }
      />
    </>
  );
};

export default DigitalRetailing;
